import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { ChevronDownIcon } from 'lucide-react';
import type { AnswerBreakdown } from '../../data/analyticsStore';
import { quizQuestions } from '../../data/quizData';
interface QuestionBreakdownProps {
  data: Record<number, AnswerBreakdown[]>;
}
function BreakdownTooltip({
  active,
  payload
}: any) {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload as AnswerBreakdown;
  return <div className="rounded-lg border border-white/10 bg-[#0c1222] px-4 py-3 shadow-xl max-w-xs" data-id="element-49">
      <p className="font-body text-xs text-white/80 leading-relaxed" data-id="element-50">
        {d.text}
      </p>
      <p className="mt-1 font-body text-xs text-white/60" data-id="element-51">
        Respuestas: <span className="text-cyan-400 font-medium" data-id="element-52">{d.count}</span>{' '}
        ({d.percent}%)
      </p>
    </div>;
}
export function QuestionBreakdown({
  data
}: QuestionBreakdownProps) {
  const [selectedQ, setSelectedQ] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const answers = data[selectedQ] || [];
  const question = quizQuestions.find(q => q.id === selectedQ);
  const maxCount = Math.max(...answers.map(a => a.count), 1);
  return <div className="rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-5" data-id="element-53">
      <div className="flex items-center justify-between mb-4" data-id="element-54">
        <h3 className="font-body text-sm font-semibold text-white" data-id="element-55">
          Respuestas por Pregunta
        </h3>
        <div className="relative" data-id="element-56">
          <button onClick={() => setDropdownOpen(!dropdownOpen)} className="inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-white/[0.06] px-3 py-1.5 font-body text-xs text-white/70 transition-colors hover:bg-white/[0.1]" data-id="element-57">
            P{selectedQ}
            <ChevronDownIcon className="h-3 w-3" data-id="element-58" />
          </button>
          {dropdownOpen && <div className="absolute right-0 top-full mt-1 z-20 max-h-48 overflow-y-auto rounded-lg border border-white/10 bg-[#0c1222] py-1 shadow-xl" data-id="element-59">
              {quizQuestions.map(q => <button key={q.id} onClick={() => {
            setSelectedQ(q.id);
            setDropdownOpen(false);
          }} className={`block w-full px-4 py-1.5 text-left font-body text-xs transition-colors ${selectedQ === q.id ? 'text-cyan-400 bg-white/[0.06]' : 'text-white/60 hover:text-white hover:bg-white/[0.04]'}`} data-id="element-60">
                  P{q.id}: {q.question.slice(0, 35)}…
                </button>)}
            </div>}
        </div>
      </div>

      {question && <p className="font-body text-xs text-white/50 mb-4 leading-relaxed" data-id="element-61">
          {question.question}
        </p>}

      {answers.length > 0 ? <div className="h-56" data-id="element-62">
          <ResponsiveContainer width="100%" height="100%" data-id="element-63">
            <BarChart data={answers} layout="vertical" margin={{
          top: 0,
          right: 4,
          bottom: 0,
          left: 4
        }} data-id="element-64">
              <XAxis type="number" tick={{
            fill: 'rgba(255,255,255,0.4)',
            fontSize: 11
          }} axisLine={false} tickLine={false} data-id="element-65" />
              <YAxis type="category" dataKey="tag" tick={false} axisLine={false} tickLine={false} width={0} data-id="element-66" />
              <Tooltip content={<BreakdownTooltip data-id="element-68" />} cursor={{
            fill: 'rgba(255,255,255,0.03)'
          }} data-id="element-67" />
              <Bar dataKey="count" radius={[0, 4, 4, 0]} barSize={20} data-id="element-69">
                {answers.map((entry, i) => <Cell key={i} fill={i === 0 ? '#00d4ff' : 'rgba(255,255,255,0.15)'} data-id="element-70" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div> : <p className="font-body text-xs text-white/30 text-center py-8" data-id="element-71">
          Sin datos para esta pregunta
        </p>}

      {answers.length > 0 && <div className="mt-3 space-y-1.5" data-id="element-72">
          {answers.map((a, i) => <div key={a.tag} className="flex items-center gap-2" data-id="element-73">
              <div className="h-2 w-2 rounded-full flex-shrink-0" style={{
          backgroundColor: i === 0 ? '#00d4ff' : 'rgba(255,255,255,0.15)'
        }} data-id="element-74" />
              <span className="font-body text-[11px] text-white/50 truncate flex-1" data-id="element-75">
                {a.text}
              </span>
              <span className="font-body text-[11px] text-white/70 font-medium" data-id="element-76">
                {a.percent}%
              </span>
            </div>)}
        </div>}
    </div>;
}